import React from 'react';
import QuestionNavigator from '../../components/QuestionNavigator/QuestionNavigator';
import QuestionBlock, { QuestionOption } from '../../components/QuestionBlock/QuestionBlock';
import { isValidOptionText } from '../../utils/questionOptions';
import './FreeQuestions.css';

const SingleFreeQuestionView = ({
  questions,
  currentQuestionIndex,
  setCurrentQuestionIndex,
  selectedOptions,
  onOptionChange,
  showAnswer,
  onAnswer,
  awnsers,
  getAnswers,
  getQuestionImageSrc,
  hasMore,
  loadingMore,
  onLoadMore
}) => {
  const totalQuestions = questions.length;
  const question = questions[currentQuestionIndex];
  const isFirst = currentQuestionIndex === 0;
  const isLastLoaded = currentQuestionIndex === totalQuestions - 1;
  const answeredCount = showAnswer.filter(Boolean).length;
  const answeredPercent = totalQuestions > 0 ? Math.round((answeredCount / totalQuestions) * 100) : 0;

  if (!question) return null;

  const goPrev = () => setCurrentQuestionIndex(Math.max(0, currentQuestionIndex - 1));
  const goNext = () => setCurrentQuestionIndex(Math.min(totalQuestions - 1, currentQuestionIndex + 1));

  const getNavStatus = (index) => {
    if (!showAnswer[index]) return '';
    return awnsers[selectedOptions[index]] === questions[index].correct ? 'correct' : 'incorrect';
  };

  return (
    <div className="single-question-layout">
      <QuestionNavigator
        count={totalQuestions}
        currentIndex={currentQuestionIndex}
        onSelect={setCurrentQuestionIndex}
        getStatus={getNavStatus}
        progress={{ percent: answeredPercent, label: `${answeredCount} respondida(s) de ${totalQuestions} carregada(s)` }}
        legend={[
          { status: 'correct', label: 'Respondida certa' },
          { status: 'incorrect', label: 'Respondida errada' },
          { status: '', label: 'Não respondida' },
        ]}
      />

      <div className="single-question-main">
        <QuestionBlock
          counterText={`Questão ${currentQuestionIndex + 1} de ${totalQuestions}`}
          subjectName={question.subjectName}
          title={question.title}
          imageSrc={question.image_url ? getQuestionImageSrc(question.image_url) : null}
          imageAlt={`Imagem da questão ${currentQuestionIndex + 1}`}
        >
          {question.questions.map((option, optionIndex) => {
            if (!isValidOptionText(option)) {
              return null;
            }
            const selected = selectedOptions[currentQuestionIndex] === optionIndex;
            return (
              <QuestionOption
                key={optionIndex}
                index={optionIndex}
                letter={getAnswers(optionIndex).replace(')', '')}
                text={option}
                selectable
                selected={selected}
                disabled={showAnswer[currentQuestionIndex]}
                status={selected ? 'selected' : ''}
                onSelect={(idx) => onOptionChange(currentQuestionIndex, option, idx)}
              />
            );
          })}
        </QuestionBlock>

        <button
          className="anwser-button"
          onClick={() => onAnswer(selectedOptions[currentQuestionIndex], currentQuestionIndex)}
          disabled={showAnswer[currentQuestionIndex]}
        >
          Responder
        </button>

        {showAnswer[currentQuestionIndex] && (
          <>
            <h3
              className={
                awnsers[selectedOptions[currentQuestionIndex]] === question.correct
                  ? "resposta-correta"
                  : "alternativa-correta"
              }
            >
              {awnsers[selectedOptions[currentQuestionIndex]] === question.correct
                ? "Parabéns, você respondeu corretamente!"
                : "A alternativa correta é a letra: " + question.correct}
            </h3>
            <h3 className="explication">Explicação: {question.explication}</h3>
            <h3 className="explication">{question.awnser}</h3>
          </>
        )}

        <div className="single-question-nav-buttons">
          <button type="button" onClick={goPrev} disabled={isFirst}>
            ← Anterior
          </button>
          {!isLastLoaded ? (
            <button type="button" onClick={goNext}>
              Próxima →
            </button>
          ) : hasMore ? (
            <button type="button" onClick={onLoadMore} disabled={loadingMore}>
              {loadingMore ? 'Carregando...' : 'Carregar mais questões'}
            </button>
          ) : (
            <span className="free-end-message">Fim das questões carregadas desta matéria</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default SingleFreeQuestionView;
